export default __webpack_public_path__ + "static/media/triangle-pattern_cri-080.03709ddb.jpg";